import React, { useState, useEffect } from "react";
import star from "../../../assets/stars.png";

// Story Card Component - Shows either story or questions
const StoryCard = ({
  story,
  onSaveResponses,
  savedResponses,
  showQuestions,
}) => {
  const [responses, setResponses] = useState({});

  useEffect(() => {
    setResponses(savedResponses || {});
  }, [savedResponses]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [showQuestions, story]);

  const handleChange = (qId, selectedOption) => {
    const updated = { ...responses, [qId]: selectedOption };
    setResponses(updated);
    onSaveResponses(updated);
  };

  return (
    <div className="bg-white rounded-lg p-6 lg:p-8">
      {/* Show either story content OR questions */}
      {!showQuestions ? (
        <>
          {/* Story Header */}
          <div className="text-center mb-8">
            <h2 className="text-xl sm:text-2xl lg:text-[32px] font-bold font-quattrocento text-[#323232] mb-4 flex items-center justify-center gap-2">
              <span className="text-teal-400">
                <img
                  src={star}
                  alt=""
                  className="w-6 h-6 lg:w-8 lg:h-8 rotate-180"
                />
              </span>
              {story.title}
              <span className="text-teal-400">
                <img src={star} alt="" className="w-6 h-6 lg:w-8 lg:h-8" />
              </span>
            </h2>
          </div>
          {/*  Story Content */}
          <div className="mb-8">
            <p className="text-[#484848] font-gotham font-medium leading-relaxed text-justify whitespace-pre-wrap text-sm sm:text-base">
              {story.description}
            </p>
          </div>
        </>
      ) : (
        /* Questions - Clean layout like reference */
        <div className="space-y-5 px-0 sm:px-6">
          {story.questions.map((question, qIndex) => (
            <div
              key={question.id}
              className="bg-white shadow-lg rounded-xl p-5"
            >
              <h3 className="text-base font-medium font-gotham sm:text-xl text-[#323232] mb-4">
                {question.question}
              </h3>

              <hr className="text-[#E3E3E3] my-3 h-2" />

              <div className="flex items-center space-x-6">
                {question.options.map((option, optIndex) => (
                  <label
                    key={optIndex}
                    className="flex items-center space-x-2 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name={`question-${story.id}-${question.id}`}
                      value={option.label}
                      checked={responses[question.id]?.label === option.label}
                      onChange={() => handleChange(question.id, option)}
                      className={`
      appearance-none h-4 w-4 rounded-full border
      ${
        responses[question.id]?.label === option.label
          ? "border-[3px] border-white ring-2 ring-[#54B0AF] bg-[#54B0AF]"
          : "border-gray-400 bg-white"
      }
    `}
                    />
                    <span
                      className={`font-gotham text-xl font-medium ${
                        responses[question.id]?.label === option.label
                          ? "text-black font-bold"
                          : "text-[#AAAAAA]"
                      }`}
                    >
                      {option.label}
                    </span>
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StoryCard;
